import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { SNACK_BAR } from '../../app.constants';
import { EncodeHelper } from '../../helpers/encode.helper';
import { Filter } from '../../interfaces/filter';
import { NotificationDTO, SuccessDTO } from '../../interfaces/models';
import { ResponseList } from '../../interfaces/responseList';

@Injectable()
export class NotificationService {
  constructor(
    private snackBar: MatSnackBar,
    private http: HttpClient,
  ) { }

  public success(message: string) {
    this.snackBar.open(message, '', SNACK_BAR.success);
  }

  public error(message: string) {
    this.snackBar.open(message, '', SNACK_BAR.error);
  }

  public markAsViewed(id: number): Observable<SuccessDTO> {
    return this.http.patch<SuccessDTO>(`${environment.api}/notifications/${id}`, {});
  }

  public getNotificationWebList(filter?: Filter): Observable<ResponseList<NotificationDTO>> {
    const filterToPass = { ...(new Filter()), filter };
    const filterQuery = EncodeHelper.encodeData(filterToPass);
    return this.http.get<ResponseList<NotificationDTO>>(`${environment.api}/notifications/web?${filterQuery}`).pipe(share());
  }
}
